import { dialog } from "nq-component";
import DialogModal from "../../../../../components/Dialog";

function CollapseView({ dp, onEdit, onView }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Date Created:</strong>{" "}
          {dp?.created &&
            new Date(dp?.created).toLocaleString("en-US", {
              month: "long", // March
              day: "numeric", // 2
              year: "numeric", // 2025
              hour: "numeric", // 5
              minute: "2-digit", // 15
              hour12: true, // am/pm
            })}
        </p>
        <p className="mb-1">
          <strong>Item Name:</strong> {dp?.itemName}
        </p>
        <p className="mb-1">
          <strong>SKU:</strong> {dp?.sku}
        </p>
        <p className="mb-1">
          <strong>Pieces / Quantity:</strong> {dp?.quantity}
        </p>

        <p className="mb-1">
          <strong>UOM:</strong> {dp?.uom?.name}
        </p>

        <p className="mb-1">
          <strong>Price:</strong> {dp?.price}
        </p>
      </div>

      <div className="d-flex gap-2">
        <button
          className="btn btn-success text-white"
          onClick={() => {
            const createdDate = new Date(dp?.created)
              .toISOString()
              .slice(0, 10);
            const today = new Date().toISOString().slice(0, 10);

            if (createdDate !== today) {
              dialog.fire({
                html: (
                  <DialogModal
                    icon="bi bi-exclamation-triangle-fill"
                    iconColor="#dc3545"
                    title="Cannot Proceed"
                    message="Cannot proceed with the adjustment because the data you are trying to adjust was not created today."
                    isCancelButton={false}
                    onSubmit={() => dialog.close()}
                  />
                ),
                footer: false,
              });
            } else {
              onEdit();
            }
          }}
        >
          <i className="bi bi-pencil-fill me-2"></i> Adjust
        </button>

        {/* <button className="btn btn-success text-white" onClick={onEdit}  disabled={
    new Date(dp?.created).toLocaleDateString() !==
    new Date().toLocaleDateString()
  }>
          <i className="bi bi-pencil-fill me-2"></i> Adjust
        </button> */}
        <button
          className="btn "
          onClick={onView}
          style={{ backgroundColor: "#d1d1d1" }}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>
      </div>
    </div>
  );
}

export default CollapseView;
